"use client";

/**
 * NewForm DS hover icon — an eye for "read only". On hover the whole eye
 * peers (the research icon's tilt), looking without touching.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function EyeIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-peer" style={{ transformOrigin: "50% 50%" }}>
        <path d="M2.8 12S6.2 5.9 12 5.9 21.2 12 21.2 12 17.8 18.1 12 18.1 2.8 12 2.8 12Z" />
        <circle cx="12" cy="12" r="2.6" />
      </g>
    </HoverIconSvg>
  );
}
